import { FilterType, Filter, VisaStatus, FilterKey } from 'api-paths-cas';
import { IGetFilterGroupsProps } from '../../types';

const VisaStatusOptions = [
  {
    label: 'CAS not received',
    value: VisaStatus.CAS_NOT_RECEIVED,
  },
  {
    label: 'CAS received',
    value: VisaStatus.CAS_RECEIVED,
  },
  {
    label: 'Visa applied',
    value: VisaStatus.VISA_APPLIED,
  },
  {
    label: 'Visa received',
    value: VisaStatus.VISA_RECEIVED,
  },
  {
    label: 'Awaiting visa response',
    value: VisaStatus.AWAITING_VISA_RESPONSE,
  },
  {
    label: 'UKVI requested more info',
    value: VisaStatus.UKVI_REQUEST_MORE_INFO,
  },
  {
    label: 'Visa refusal',
    value: VisaStatus.VISA_REFUSAL,
  },
  {
    label: 'Intends to defer',
    value: VisaStatus.INTENDS_TO_DEFER,
  },
  {
    label: 'Intends to withdraw',
    value: VisaStatus.INTENDS_TO_WITHDRAW,
  },
  {
    label: 'None',
    value: VisaStatus.NONE,
  },
];

const key = FilterKey.VISA_STATUS;
export const getVisaStatusFilter = ({ activeFilters }: IGetFilterGroupsProps): Filter => {
  const filters = activeFilters[key] ?? [];
  const options = VisaStatusOptions.map(({ label, value }) => {
    return {
      label,
      value,
      checked: filters.some(filter => filter === value),
    };
  });

  return {
    name: 'Visa status',
    key,
    type: FilterType.SELECT_MANY,
    showSearch: false,
    options: {
      SELECT_MANY: options,
    },
  };
};
